/**
 * @author Jorge Casas
 * @creationDate 22/04/2024
 */

import React, { useRef, useState } from 'react';
import AssetsFormSections from 'components/assets/form_sections';
import { Form } from 'common/components';
import { putEditCustomsDocuments } from '../actions';
import AssetCustomsDocumentsTable from '../../../modules/secured/modules/assets/AssetCustomsDocumentsTable';
import AssetCustomsDocumentsRow from '../../../modules/secured/modules/assets/AssetsCustomsDocsRow';
import * as Common from 'common/components';
import CustomsDocumentsAddButton from '../../../components/assets/form_sections/CustomsDocumentsAddButton';
import { formatDate } from '../../../utils/additional-functions/formatted-date.js';
import { formatMoney } from 'accounting-js';
import { translate } from 'react-i18next';

/**
 * @author Jorge
 * @creationDate 22/04/2024
 *
 * @description Function to edit customs documents
 *
 * @function AssetsEditCustomsDocuments
 *
 * @param {Object} props
 * @param {Object} props.asset
 * @param {Object} props.company
 * @param {Object} props.subcompany
 * @param {Object} props.history
 * @param {Function} props.t
 * @returns {React.Component}
 */
const AssetsEditCustomsDocuments = (props) => {
  const { catalogs = {}, asset, company, subcompany, history, t = () => {} } = props;

  const [files, setFiles] = useState([]);
  const [isCollapsed, setIsCollapsed] = useState(true);
  const [values, setValues] = useState({
    customsDocumentsPedimentoNumber: '',
    customsDocumentsPedimentoKey: '',
    customsDocumentsCustomsKey: '',
    customsDocumentsDate: '',
    customsDocumentStatus: '',
    customsDocumentsImport: '',
    customsDocumentsQuantity: '',
  });
  let totalImports = 0;
  var fechaInicial;
  var fechaFinal;

  if (asset._customsDocuments && asset._customsDocuments.length > 0) {
    if (asset._customsDocuments[0].customsDocumentsDate !== undefined)
      fechaInicial = asset._customsDocuments[0].customsDocumentsDate;
    else if (asset._customsDocuments[1].customsDocumentsDate !== undefined)
      fechaInicial = asset._customsDocuments[1].customsDocumentsDate;

    if (asset._customsDocuments[0].customsDocumentsDate !== undefined)
      fechaFinal = asset._customsDocuments[0].customsDocumentsDate;
    else if (asset._customsDocuments[1].customsDocumentsDate !== undefined)
      fechaFinal = asset._customsDocuments[1].customsDocumentsDate;

    for (const customsDocuments in asset._customsDocuments) {
      if (asset._customsDocuments[customsDocuments].customsDocumentsImport)
        totalImports += asset._customsDocuments[customsDocuments].customsDocumentsImport;

      for (
        let index = parseInt(customsDocuments) + 1;
        index < asset._customsDocuments.length;
        index++
      ) {
        if (asset._customsDocuments[index].customsDocumentsDate) {
          if (fechaInicial > asset._customsDocuments[index].customsDocumentsDate) {
            fechaFinal = fechaInicial;
            fechaInicial = asset._customsDocuments[index].customsDocumentsDate;
          } else if (asset._customsDocuments[index].customsDocumentsDate > fechaFinal)
            fechaFinal = asset._customsDocuments[index].customsDocumentsDate;
        }
      }
    }
    fechaInicial = formatDate(fechaInicial);
    fechaFinal = formatDate(fechaFinal);
  }

  const handleValueChange = (e) => {
    if (e._d) {
      setValues({ ...values, [e.target.name]: e.target.value, customsDocumentsDate: e._d });
    } else {
      setValues({ ...values, [e.target.name]: e.target.value });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    putEditCustomsDocuments(asset.id, company.id, subcompany.id, values, files)
      .then((resultado) => {
        if (resultado.payload) {
          history.goBack();
        }
      })
      .catch((error) => {
        console.error(error);
      });
    setFiles([]);
  };

  const hiddenFileInput = useRef(null);

  const handleClick = (event) => {
    hiddenFileInput.current.click();
  };
  const handleFileChange = (e) => {
    setFiles([...files, e.target.files[0]]);
  };
  return (
    <Common.Wrapper fluid={true}>
      <div className="col-12">
        <Common.Portlet
          title={`${t('assets.section.customs_documents_title')}`}
          button={
            <CustomsDocumentsAddButton setIsCollapsed={setIsCollapsed} isCollapsed={isCollapsed} />
          }
        >
          {isCollapsed ? null : (
            <form onSubmit={(e) => handleSubmit(e)} noValidate autoComplete="false">
              <AssetsFormSections.CustomsDocuments
                catalogs={catalogs}
                handleValueChange={handleValueChange}
                handleFileChange={handleFileChange}
                handleClick={handleClick}
                hiddenFileInput={hiddenFileInput}
                values={values}
                name={files.length > 0 ? files : ''}
              />

              <div className="col-md-12 mt-3">
                <Form.Button
                  type={'submit'}
                  text={t('acl.assetsCustomsDocuments.save')}
                  extraClassName={'pull-right btn-xs-block'}
                />

                <div className="clearfix" />
              </div>
            </form>
          )}

          <div className="mb-2 mt-5" style={{ position: 'relative' }}>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              <div style={{ marginRight: '20px' }}>
                {asset._customsDocuments
                  ? `${t('acl.assetsCustomsDocuments.total_pedimentos')}: ${
                      asset._customsDocuments.length
                    }`
                  : `${t('acl.assetsCustomsDocuments.total_pedimentos')}: 1`}
              </div>
              <div style={{ marginRight: '20px' }}>
                {asset._customsDocuments
                  ? `${t('acl.assetsCustomsDocuments.accumulated_import')}: ${formatMoney(
                      totalImports / 100
                    )}`
                  : `${t('acl.assetsCustomsDocuments.accumulated_import')}: ${
                      asset.customsDocumentsImport ? formatMoney(asset.customsDocumentsImport) : '-'
                    }`}
              </div>
              <div>
                {fechaInicial && fechaFinal
                  ? `${t('acl.assetsCustomsDocuments.from')} ${fechaInicial} ${t(
                      'acl.assetsCustomsDocuments.to'
                    )} ${fechaFinal}`
                  : null}
              </div>
            </div>
            <br />

            <AssetCustomsDocumentsTable
              count={asset._customsDocuments ? asset._customsDocuments.length : 1}
            >
              {asset._customsDocuments ? (
                asset._customsDocuments
                  .filter((customsDocument) => !customsDocument.deleted)
                  .map((customsDocuments) => (
                    <AssetCustomsDocumentsRow
                      assetId={asset.id}
                      companyId={company.id}
                      subcompanyId={subcompany.id}
                      customsDocuments={customsDocuments}
                      catalogs={catalogs}
                    />
                  ))
              ) : (
                <AssetCustomsDocumentsRow
                  customsDocuments={{
                    customsDocumentsPedimentoNumber: asset.customsDocumentsPedimentoNumber,
                    customsDocumentsPedimentoKey: asset.customsDocumentsPedimentoKey,
                    customsDocumentsCustomsKey: asset.customsDocumentsCustomsKey,
                    customsDocumentsDate: asset.customsDocumentsDate,
                    customsDocumentStatus: asset.customsDocumentStatus,
                    customsDocumentsImport: asset.customsDocumentsImport,
                    customsDocumentsQuantity: asset.customsDocumentsQuantity,
                  }}
                />
              )}
            </AssetCustomsDocumentsTable>
          </div>
        </Common.Portlet>
      </div>
    </Common.Wrapper>
  );
};

export default translate()(AssetsEditCustomsDocuments);



// WEBPACK FOOTER //
// src/containers/assets/edit_sections/AssetsEditCustomsDocuments.js